module.exports = __webpack_public_path__ + "static/img/5.61bdf02.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ppt/5.jpg
// module id = 9YR/
// module chunks = 1